// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d0JNC","newExpiryDate":"styles_newExpiryDate__2M6RY","footer":"styles_footer__qhjH6"};